import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { LeadDialog } from "@/components/LeadDialog";
import { Eyebrow } from "@/components/Reveal";
import { useContent } from "@/hooks/useData";
import { imgUrl } from "@/lib/api";

export const CtaBand = () => {
  const { content } = useContent();
  const c = content.cta;
  return (
    <section className="relative overflow-hidden" data-testid="cta-band">
      <div className="absolute inset-0">
        <img src={imgUrl(c.image_url)} alt="Elegant living room" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-[#2C2A29]/70" />
      </div>
      <div className="relative max-w-4xl mx-auto px-5 sm:px-8 py-28 sm:py-40 text-center text-[#FFFFFF]">
        <Eyebrow className="!text-[#ECEAE4]">{c.eyebrow}</Eyebrow>
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="font-display text-4xl sm:text-6xl font-medium leading-[1.05] mt-5"
        >
          {c.title}
          <br />
          <span className="italic text-[#D9C9B6]">{c.accent}</span>
        </motion.h2>
        <p className="mt-6 text-lg text-[#ECEAE4] font-light max-w-xl mx-auto">{c.subtitle}</p>
        <div className="mt-10">
          <LeadDialog
            trigger={
              <Button className="rounded-none bg-[#FFFFFF] text-[#2C2A29] hover:bg-[#ECEAE4] h-14 px-10 label-eyebrow text-[11px]" data-testid="cta-band-button">
                {c.button}
              </Button>
            }
          />
        </div>
      </div>
    </section>
  );
};
